query getGenerationStats {
  generationStats: getGenerationStats {
    textCount
    imageCount
  }
}
